// Loading Actions
export const SET_LOADING = "SET_LOADING";

// Alert Actions
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const CLEAR_ALERT = "CLEAR_ALERT";

// Auth Actions
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";
export const RESET_REQUEST_SUCCESS = "RESET_REQUEST_SUCCESS";
export const RESET_REQUEST_FAIL = "RESET_REQUEST_FAIL";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

// User Actions
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILED = "REGISTER_FAILED"
export const GET_USERS = "GET_USERS";
export const UPDATE_USER = "UPDATE_USER";
export const USER_ACTION_FAIL = "USER_ACTION_FAIL";

// Dashboard Actions
export const GET_DASHBOARD_DISPUTES = "GET_DASHBOARD_DISPUTES";
export const GET_DASHBOARD_PAYMENTS = "GET_DASHBOARD_PAYMENTS";
export const GET_DASHBOARD_TOP_STORES = "GET_DASHBOARD_TOP_STORES";
export const GET_DASHBOARD_TOP_PRODUCTS = "GET_DASHBOARD_TOP_PRODUCTS";
export const GET_DASHBOARD_TOP_CAMPAIGNS = "GET_DASHBOARD_TOP_CAMPAIGNS";
export const DASHBOARD_ERROR = "DASHBOARD_ERROR";
export const GET_DASHBOARD_SHOPIFY = "GET_DASHBOARD_SHOPIFY";

// Order Actions
export const GET_ORDER_BY_TID = "GET_ORDER_BY_TID";
export const FILTER_ORDERS = "FILTER_ORDERS";
export const ORDER_ERROR = "ORDER_ERROR";

// Order v1 Actions
export const SET_SEARCH_FILTER = "SET_SEARCH_FILTER";
export const SEARCH_ORDER = "SEARCH_ORDER";
export const SET_ORDER_MODAL = "SET_ORDER_MODAL";
export const SET_MODAL_VALUES = "SET_MODAL_VALUES";
export const SET_MODAL_ERRORS = "SET_MODAL_ERRORS";
export const SET_MODAL_STATES = "SET_MODAL_STATES";
export const SET_ORDER = "SET_ORDER";
export const UPDATE_CONTACT_INFO = "UPDATE_CONTACT_INFO";
export const UPDATE_SHIPPING_ADD = "UPDATE_SHIPPING_ADD";
export const CREATE_ORDER_FULFILLMENT = "CREATE_ORDER_FULFILLMENT";
export const EDIT_ORDER_FULFILLMENT = "EDIT_ORDER_FULFILLMENT";
export const CALCULATE_ORDER_REFUND = "CALCULATE_ORDER_REFUND";
export const CREATE_ORDER_REFUND = "CREATE_ORDER_REFUND";
export const CLEAR_REFUND = "CLEAR_REFUND";
export const GET_TRANSACTIONS = "GET_TRANSACTIONS";

// Store Actions
export const GET_ACTIVE_STORES = "GET_ACTIVE_STORES";
export const GET_STORES = "GET_STORES";
export const FILTER_STORES = "FILTER_STORES";
export const CLEAR_FILTERED_STORES = "CLEAR_FILTERED_STORES";
export const SEARCH_STORES = "SEARCH_STORES";
export const SELECTED_STORE = "SELECTED_STORE";
export const STORE_ERROR = "STORE_ERROR";

// Product Actions
export const GET_PRODUCTS = "GET_PRODUCTS";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_ALL_PRODUCTS = "SET_ALL_PRODUCTS";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const FILTER_PRODUCTS = "FILTER_PRODUCTS";
export const CLEAR_PRODUCT_FILTER = "CLEAR_PRODUCT_FILTER";
export const SET_CURRENT_PRODUCT = "SET_CURRENT_PRODUCT";
export const CLEAR_CURRENT_PRODUCT = "CLEAR_CURRENT_PRODUCT";
export const PRODUCT_ERROR = "PRODUCT_ERROR";
export const CLEAR_PRODUCTS = "CLEAR_PRODUCTS";

// Checkout Actions
export const GET_CHECKOUTS = "GET_CHECKOUTS";
export const FILTER_CHECKOUTS = "FILTER_CHECKOUTS";
export const CLEAR_FILTERED_CHECKOUTS = "CLEAR_FILTERED_CHECKOUTS";
export const SELECTED_CHECKOUT = "SELECTED_CHECKOUT";
export const SELECTED_PRODUCT = "SELECTED_PRODUCT";
export const CHECKOUT_ERROR = "CHECKOUT_ERROR";

// Paypal Actions
// Paypal Dispute Actions
export const GET_DISPUTE_BY_ID = "GET_DISPUTE_BY_ID";
export const GET_DISPUTES_SORTED_BY_DATE = "GET_DISPUTES_SORTED_BY_DATE";
export const DISPUTE_ERROR = "DISPUTE_ERROR";
export const RETURNED_DATA = "RETURNED_DATA";
export const RETURNED_DATA_ERROR = "RETURNED_DATA_ERROR";

// Paypal Payment Actions
export const GET_PAYMENTS = "GET_PAYMENTS";
export const GET_PAYMENTS_ERROR = "GET_PAYMENTS_ERROR";
export const GET_UNMATCHED = "GET_UNMATCHED";
export const GET_PAYMENT = "GET_PAYMENT";
export const GET_PAYMENT_ERROR = "GET_PAYMENT_ERROR";
export const GET_DETAILS = "GET_DETAILS";
export const GET_DETAILS_ERROR = "GET_DETAILS_ERROR";
export const EDIT_CUSTOMER_INFO = "EDIT_CUSTOMER_INFO";
export const PAYMENT_ORDER_POSTING = "PAYMENT_ORDER_POSTING";
export const PAYMENT_ACTION_ERROR = "PAYMENT_ACTION_ERROR";

// Campaign v2 - Campaign Actions
export const SET_LANDER_URL = "SET_LANDER_URL";
export const GET_CAMPAIGN = "GET_CAMPAIGN";
export const CAMPAIGN_ERROR = "CAMPAIGN_ERROR";
export const SEARCH_CHECKOUT = "SEARCH_CHECKOUT";
export const CHECKOUT_LOADING = "CHECKOUT_LOADING";
export const CHECKOUT_DATA = "CHECKOUT_DATA";
export const AGENCY_ACCOUNT = "AGENCY_ACCOUNT";
export const RESET_CAMPAIGN = "RESET_CAMPAIGN";

// Campaign - Active Campaign Actions
export const SET_EXIST_FORM_DATA = "SET_EXIST_FORM_DATA";
export const SET_CAMP_FORM_DATA = "SET_CAMP_FORM_DATA";
export const SET_CAMP_FORM_ERROR = "SET_CAMP_FORM_ERROR";
export const SET_CAMP_FORM_STATES = "SET_CAMP_FORM_STATES";
export const SET_CAMP_RETURN_DATA = "SET_CAMP_RETURN_DATA";
export const OPEN_MODAL = "OPEN_MODAL";
export const ACTIVE_CAMPAIGN_ERROR = "ACTIVE_CAMPAIGN_ERROR";

// Campaign - Search Actions
export const GET_CAMPAIGNS = "GET_CAMPAIGNS";
export const CAMP_SEARCH_ERROR = "CAMP_SEARCH_ERROR";

// Fulfillment Actions
export const GET_UNFULFILL = "GET_UNFULFILL";
export const GET_UNFULFILL_ERROR = "GET_UNFULFILL_ERROR";
export const GET_UNFULFILL_BY_ID = "GET_UNFULFILL_BY_ID";

// Tracking Actions
export const GET_TRACKING = "GET_TRACKING";
export const GET_TRACKING_ERROR = "GET_TRACKING_ERROR";
export const FULFILL_ORDER = "FULFILL_ORDER";
export const FULFILL_ORDER_PROGRESS = "FULFILL_ORDER_PROGRESS";

// Monitoring Actions
export const GET_MONITORING = "GET_MONITORING";
export const GET_MONITORING_ERROR = "GET_MONITORING_ERROR";
export const GET_DUPLICATED_EMAIL = "GET_DUPLICATED_EMAIL";
export const GET_MISSING_PAYMENTS = "GET_MISSING_PAYMENTS";
export const GET_PENDING_PAYMENTS = "GET_PENDING_PAYMENTS";

// Discount Actions
export const GET_DISCOUNTS = "GET_DISCOUNTS";
export const FILTER_DISCOUNTS = "FILTER_DISCOUNTS";
export const CLEAR_FILTERED_DISCOUNTS = "CLEAR_FILTERED_DISCOUNTS";
export const SELECTED_DISCOUNT = "SELECTED_DISCOUNT";
export const FORM_DATA = "FORM_DATA";
export const FORM_ERROR = "FORM_ERROR";
export const DISCOUNT_ERROR = "DISCOUNT_ERROR";

// Mern Product Actions
export const GET_MERN_PRODUCTS = "GET_MERN_PRODUCTS";
export const MERN_LOADING = "MERN_LOADING";
export const MERN_PRODUCTS_ERROR = "MERN_PRODUCTS_ERROR";

// Mern Country Actions
export const GET_MERN_COUNTRIES = "GET_MERN_COUNTRIES";
export const GET_MERN_COUNTRY = "GET_MERN_COUNTRY";
export const MERN_COUNTRY_ERROR = "MERN_COUNTRY_ERROR";

// Parameter Actions
export const GET_BEMOB_SETUP = "GET_BEMOB_SETUP";
export const FB_COST_BUFFER = "FB_COST_BUFFER";
export const GET_CHECKOUT_LANGUAGES = "GET_CHECKOUT_LANGUAGES";
export const GET_BEMOB_COUNTRY = "GET_BEMOB_COUNTRY";
export const GET_USER_GROUP = "GET_USER_GROUP";
export const GET_SHOPIFY_MENU_LIST = "GET_SHOPIFY_MENU_LIST";
export const GET_DOMAIN_LIST = "GET_DOMAIN_LIST";
export const COLOR_CODE = "COLOR_CODE";
export const POSTING_STORE = "POSTING_STORE";
export const OWNER_STORE = "OWNER_STORE";
export const PARAMETER_ERROR = "PARAMETER_ERROR";

// Report Actions
export const GET_REPORTS = "GET_REPORTS";
export const GET_REPORTS_ERROR = "GET_REPORTS_ERROR";
export const FILTERED_REPORTS = "FILTERED_REPORTS";
export const FILTER_BY_STORE = "FILTER_BY_STORE";
export const DATE_RANGE = "DATE_RANGE";
export const CAMPAIGN_OWNER = "CAMPAIGN_OWNER";
export const REPORT_TYPE = "REPORT_TYPE";

// Logs Actions
export const GET_LOGS = "GET_LOGS";
export const LOGS_ERROR = "LOGS_ERROR";

// Facebook Status Log Actions
export const GET_FB_STATUS_LOG = "GET_FB_STATUS_LOG";
export const GET_FB_ALERT = "GET_FB_ALERT";
export const FB_STATUS_LOG_ERROR = "FB_STATUS_LOG_ERROR";

// Facebook Profiles Actions
export const GET_FACEBOOK_PROFILES = "GET_FACEBOOK_PROFILES";
export const FILTER_PROFILES = "FILTER_PROFILES";
export const CLEAR_FILTERED_PROFILES = "CLEAR_FILTERED_PROFILES";
export const SET_PROFILE = "SET_PROFILE";
export const SELECTED_PROFILE = "SELECTED_PROFILE";
export const SELECTED_FACEBOOK_DETAILS = "SELECTED_FACEBOOK_DETAILS";
export const SET_TOGGLE_ADS = "SET_TOGGLE_ADS";
export const SET_DISPLAY_CONTENT = "SET_DISPLAY_CONTENT";
export const SET_CURRENT_TAB = "SET_CURRENT_TAB";
export const STATS_FILTER = "STATS_FILTER";
export const CAMPAIGN_DETAILS = "CAMPAIGN_DETAILS";
export const ADSET_DETAILS = "ADSET_DETAILS";
export const AD_DETAILS = "AD_DETAILS";
export const CAMPAIGN_FILTERED = "CAMPAIGN_FILTERED";
export const ADSET_FILTERED = "ADSET_FILTERED";
export const AD_FILTERED = "AD_FILTERED";
export const CAMPAIGN_SELECTED = "CAMPAIGN_SELECTED";
export const ADSET_SELECTED = "ADSET_SELECTED";
export const AD_SELECTED = "AD_SELECTED";
export const GET_PROFILE_ERROR = "GET_PROFILE_ERROR";
export const FACEBOOK_PROFILES_ERROR = "FACEBOOK_PROFILES_ERROR";

// Facebook Campaign Actions
export const FACEBOOK_CAMPAIGN_FORM_DETAILS = "FACEBOOK_CAMPAIGN_FORM_DETAILS";
export const FACEBOOK_CAMPAIGN_FORM_ERROR = "FACEBOOK_CAMPAIGN_FORM_ERROR";
export const FACEBOOK_CAMPAIGN_ID = "FACEBOOK_CAMPAIGN_ID";
export const FACEBOOK_CAMPAIGN_ERROR = "FACEBOOK_CAMPAIGN_ERROR";

// Facebook Ad Set Actions
export const FACEBOOK_ADSET_FORM_DETAILS = "FACEBOOK_ADSET_FORM_DETAILS";
export const FACEBOOK_ADSET_FORM_ERROR = "FACEBOOK_ADSET_FORM_ERROR";
export const FACEBOOK_ADSET_ID = "FACEBOOK_ADSET_ID";
export const FACEBOOK_ADSET_ERROR = "FACEBOOK_ADSET_ERROR";

// Facebook Ad Actions
// export const CLOUDINARY_PUBLIC_ID = "CLOUDINARY_PUBLIC_ID";
export const FACEBOOK_AD_FORM_DETAILS = "FACEBOOK_AD_FORM_DETAILS";
export const FACEBOOK_AD_FORM_ERROR = "FACEBOOK_AD_FORM_ERROR";
export const FACEBOOK_AD_ID = "FACEBOOK_AD_ID";
export const FACEBOOK_AD_ERROR = "FACEBOOK_AD_ERROR";

// Facebook Rules Actions
export const GET_FACEBOOK_RULES = "GET_FACEBOOK_RULES";
export const FILTER_FACEBOOK_RULES = "FILTER_FACEBOOK_RULES";
export const CLEAR_FILTERED_FACEBOOK_RULES = "CLEAR_FILTERED_FACEBOOK_RULES";
export const SELECTED_FACEBOOK_RULE = "SELECTED_FACEBOOK_RULE";
export const FACEBOOK_RULE_ERROR = "FACEBOOK_RULE_ERROR";

// Facebook Notification Actions
export const GET_FACEBOOK_NOTIFICATIONS = "GET_FACEBOOK_NOTIFICATIONS";
export const FACEBOOK_NOTIFICATION_UPDATED = "FACEBOOK_NOTIFICATION_UPDATED";
export const FACEBOOK_NOTIFICATION_ERROR = "FACEBOOK_NOTIFICATION_ERROR";

// Cloudinary Actions
export const CLOUDINARY_BROWSE_LOADING = "CLOUDINARY_BROWSE_LOADING";
export const CLOUDINARY_VIDEO_URL = "CLOUDINARY_VIDEO_URL";
export const CLOUDINARY_VIDEO_ERROR = "CLOUDINARY_VIDEO_ERROR";
export const CLOUDINARY_VIDEOS = "CLOUDINARY_VIDEOS";
export const CLOUDINARY_IMAGE_URL = "CLOUDINARY_IMAGE_URL";
export const CLOUDINARY_IMAGES = "CLOUDINARY_IMAGES";
export const CLOUDINARY_CREATE_AVATAR = "CLOUDINARY_CREATE_AVATAR";

// Domain Actions
export const SET_PROJECTS = "SET_PROJECTS";
export const SET_DOMAINS = "SET_DOMAINS";
export const NEW_DOMAIN = "NEW_DOMAIN";
export const NEW_DOMAIN_ERROR = "NEW_DOMAIN_ERROR";
export const FILTER_DOMAINS = "FILTER_DOMAINS";
export const EDIT_DOMAIN = "EDIT_DOMAIN";

// Scaling Management Actions
export const SET_CAMPAIGNS = "SET_CAMPAIGNS";
export const SET_CAMPAIGNS_SEARCHED = "SET_CAMPAIGNS_SEARCHED";
export const SET_SORT_VALUE = "SET_SORT_VALUE";
export const SET_SEARCH_VALUE = "SET_SEARCH_VALUE";
export const EDIT_CAMPAIGN = "EDIT_CAMPAIGN";
export const SET_SCALING_STATUS = "SET_SCALING_STATUS";
